import { render, staticRenderFns } from "./SocketError.vue?vue&type=template&id=1d441a94&"
import script from "./SocketError.vue?vue&type=script&lang=js&"
export * from "./SocketError.vue?vue&type=script&lang=js&"
import style0 from "./SocketError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports